import { Icon } from "@circle-react-shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { noop } from "lodash";
import type { KeyboardEvent } from "react";

import { t } from "@/i18n-js/instance";

interface Props {
  className?: string;
  onChange: (value: string) => void;
  onClickCancel?: () => void;
  onKeyPress: (event: KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  searchValue: string;
  shouldAutoFocus?: boolean;
  showCancelButton?: boolean;
}

export const SearchInput = ({
  onChange,
  searchValue,
  onKeyPress,
  onClickCancel = noop,
  placeholder = t("messaging.actions.search_name"),
  className = "",
  showCancelButton = false,
  shouldAutoFocus = false,
}: Props) => (
  <div
    className={classNames(
      "bg-primary isolate z-10 mx-2 flex w-full items-center justify-between gap-4",
    )}
  >
    <div
      className={classNames(
        "bg-secondary-dark active:border-very-dark focus-within:bg-primary focus-within:border-very-dark active:bg-primary hover:border-dark hover:focus-within:border-very-dark border-hover group flex h-8 w-full flex-1 items-center gap-2 overflow-hidden rounded-md border p-3 marker:mr-0 hover:bg-transparent md:p-1",
        className,
      )}
    >
      <Icon
        type="16-search-v3"
        className="text-light group-focus-within:text-dark group-active:text-dark ml-2"
        size={16}
        useWithFillCurrentColor
      />
      <input
        className="text-darkest placeholder:text-light text-sm w-full rounded-sm bg-transparent font-medium outline-none placeholder:opacity-100 sm:rounded-none"
        placeholder={placeholder}
        data-name="v2-search"
        data-testid="v2-search"
        aria-autocomplete="list"
        value={searchValue}
        onChange={e => onChange(e.target.value)}
        onKeyPress={onKeyPress}
        autoFocus={shouldAutoFocus}
      />
      {(searchValue || showCancelButton) && (
        <Icon
          type="20-close"
          className="text-dark mr-2 !h-5 !w-5 cursor-pointer"
          size={20}
          useWithFillCurrentColor
          onClick={onClickCancel}
        />
      )}
    </div>
  </div>
);
